<template>
  <div>
    <div class="orders-head">
      <div
        :class="{ 'bg-primary': isKioskMode }"
        class="orders-top"
      >
        <div class="d-flex align-items-center">
          <div
            v-if="currentOrder.id || currentOrder.local_id"
            class="orders-top-num"
          >
            <span>
              {{ $t("amountandpaymentmethod.order-no") }}
            </span>
            <strong># {{ displayOrderWithTable }}</strong>
          </div>

          <div
            v-if="isKioskMode && orderPanelOrderDiningOption"
            class="orders-top-num ml-auto"
          >
            <span>Order Type</span>
            <strong> {{ orderPanelOrderDiningOption.name }}</strong>
          </div>

          <div class="orders-top-btn ml-auto d-sm-flex align-items-center">
            <b-button
              v-if="(orderPanelOrderDiningOption && orderPanelOrderDiningOption.name) || defaultDiningOption"
              :class="{ 'd-none': isKioskMode }"
              :disabled="$route.params.id === 'new'"
              variant="dark"
              @click="isSavingProcess ? null : showDiningOptionsModal()"
            >
              {{
                orderPanelOrderDiningOption && orderPanelOrderDiningOption.name
                  ? orderPanelOrderDiningOption.name
                  : defaultDiningOption ? defaultDiningOption.name : ""
              }}
            </b-button>
            <b-button
              v-if="!isKioskMode"
              :disabled="$route.params.id === 'new'"
              variant="secondary"
              @click="isSavingProcess ? null : $emit('cancelOrder')"
            >
              {{ $t("orderscreen.cancel-order") }}
            </b-button>
            <b-button
              v-if="isKioskMode"
              variant="secondary"
              @click="isSavingProcess ? null : $emit('cancelOrder')"
            >
              {{ $t("orderscreen.cancel-order") }}
            </b-button>
          </div>
        </div>
      </div>

      <div
        v-if="isKioskMode"
        class="orders-list-th"
      >
        <div class="d-flex align-items-center h-100 justify-content-between">
          <div class="th">
            QTY
          </div>
          <div class="th">
            PRODUCT NAME
          </div>
          <div class="th ml-auto">
            PRICE
          </div>
        </div>
      </div>
      <div
        v-if="!isKioskMode"
        class="orders-add"
      >
        <div
          v-if="!currentOrder.customer && !discountEmployee"
          class="d-flex align-items-center justify-content-between w-100"
        >
          <b-button
            variant="link"
            @click="showSelectCustomerModal"
          >
            <div>
              <svg class="icon icon-icon-add">
                <use xlink:href="#icon-icon-add" />
              </svg>
              <span>
                {{ $t("orderscreen.add-customer") }}
              </span>
            </div>
          </b-button>
          <b-button
            v-if="allowCashDiscount && allowCashDiscount.value === 'true'"
            :variant="currentOrder && currentOrder.cash_discount ? 'primary' : 'outline-light'"
            @click="toggleCashDiscount"
          >
            {{ $t("orderscreen.cash-discount") }}
            {{ currentOrder && currentOrder.cash_discount ? $t("orderscreen.on") : $t("orderscreen.off") }}
          </b-button>
        </div>
        <div
          v-else-if="currentOrder.customer"
          class="d-flex align-items-center justify-content-between w-100 px-1"
        >
          <div
            class="d-flex align-items-center cursor-pointer"
            @click="showSelectCustomerModal"
            style="cursor: pointer; overflow: hidden; max-width: 50%;"
          >
            <div class="customer-avatar mr-2 rounded-circle d-flex align-items-center justify-content-center flex-shrink-0">
              {{ getCustomerInitials(currentOrder.customer) }}
            </div>
            <span
              class="text-truncate font-weight-bold text-dark"
              style="font-size: 1.1rem;"
            >
              {{ currentOrder.customer.first_name }} {{ currentOrder.customer.last_name }}
            </span>
          </div>
          <div class="d-flex align-items-center flex-shrink-0">
            <b-button
              v-if="isRewardsModuleEnabled"
              class="text-white font-weight-bold mr-2 text-nowrap btn-points border-0"
              size="lg"
              @click="$emit('showPointsRedemptionModal')"
            >
              {{ effectiveCustomerPoints }} Points
            </b-button>
          </div>
        </div>
        <div
          v-else-if="discountEmployee"
          class="d-flex align-items-center justify-content-between w-100 px-1"
        >
          <div
            class="d-flex align-items-center cursor-pointer"
            @click="showSelectCustomerModal"
            style="cursor: pointer; overflow: hidden; max-width: 50%;"
          >
            <div class="customer-avatar mr-2 rounded-circle d-flex align-items-center justify-content-center flex-shrink-0">
              {{ getEmployeeInitials(discountEmployee) }}
            </div>
            <span
              class="text-truncate font-weight-bold text-dark"
              style="font-size: 1.1rem;"
            >
              {{ discountEmployee.name }}
            </span>
          </div>
          <div class="d-flex align-items-center flex-shrink-0">
            <span class="badge badge-info text-nowrap">
              {{ $t("orderscreen.employee") }}
            </span>
          </div>
        </div>
      </div>
    </div>

    <div
      id="orders-sidebar-body"
      class="orders-sidebar-body"
    >
      <div
        :class="{ 'orders-list-kiosk': isKioskMode }"
        class="orders-list"
        role="tablist"
      >
        <div
          v-if="!itemsAtCurrentOrder.length && isKioskMode"
          class="orders-empty-kiosk"
        >
          <h5>
            Your card is empty
          </h5>
          <p>
            Please, add items to get started.
          </p>

          <img
            src="@/assets/images/powered.svg"
            class="kiosk-powered"
          >
        </div>
        <div v-if="!isKioskMode">
          <b-card
            v-for="(item, index) in orderItems"
            :key="item.id"
            :class="{ 'sent_to_kitchen': item.sent_to_kitchen, 'points-redeemed-item': item.name === 'Points Redeemed' }"
            no-body
            class="list-complete-item"
          >
            <b-card-header
              header-tag="header"
              :class="{ 'points-redeemed-head': item.name === 'Points Redeemed' }"
              class="orders-item-head p-0"
              role="tab"
            >
              <b-button
                v-b-toggle="'accordion-' + index"
                block
                href="#"
              >
                <div class="d-flex">
                  <div class="btn-num">
                    {{ item.quantity }}
                  </div>

                  <div class="btn-body">
                    <div class="d-flex align-items-center justify-content-between top text-nowrap">
                      <div class="text-left">
                        <span class="item-name">
                          {{ getItemDisplayName(item) }}
                        </span>
                        <span
                          v-if="item.name === 'Points Redeemed'"
                          class="badge badge-rewards ml-2"
                        >★ REWARDS</span>
                        <span
                          v-if="item.allow_discounts === false"
                          class="badge badge-secondary ml-2"
                        >{{ $t("orderscreen.ineligible-for-discount") }}</span>
                        <svg
                          v-if="item.notes && item.notes.length"
                          class="icon icon-icon-note"
                        >
                          <use xlink:href="#icon-icon-note" />
                        </svg>
                      </div>
                      <div class="text-right">
                        <span
                          v-if="(item.tax > 0 || item.price === 0) && item.tax_status === 0 && !isKioskMode"
                          class="short-desc"
                        >{{ $t("listvieworderdelegate.taxed") }}</span>
                        {{ currency }} {{ (item.isPromotionItem && item.price === 0) ? '0.00' : (item.grand_total || 0).toFixed(2) }}
                      </div>
                    </div>
                  </div>
                </div>
              </b-button>
            </b-card-header>

            <b-collapse
              :id="'accordion-' + index"
              :visible="showCollapse(index)"
              accordion="my-accordion"
              role="tabpanel"
              class="sub-accordion"
            >
              <b-card-body>
                <div
                  v-if="item.discount > 0 || item.wholeDiscount > 0 || item.wholeDiscount < 0"
                  class="d-flex align-items-center justify-content-between sub-discount text-nowrap"
                >
                  <div class="text-left">
                    {{ currency }} {{ $t("orderscreen.discount") }}
                    <template v-if="item.promotion_applied">
                      <span
                        v-if="item.applied_promotions && item.applied_promotions.length > 0"
                        v-for="(promo, idx) in item.applied_promotions"
                        :key="idx"
                        class="badge badge-info ml-1"
                      >{{ promo.promotionName }}</span>
                      <span
                        v-else
                        class="badge badge-info ml-1"
                      >PROMO</span>
                    </template>
                  </div>
                  <div class="text-right">
                    {{ currency }} {{ roundOffDiscounts(item).toFixed(2) }}
                  </div>
                </div>
                <div
                  v-if="item.applied_promotions && item.applied_promotions.length > 0"
                  class="d-flex align-items-center justify-content-between sub-promotion text-nowrap"
                >
                  <div class="text-left">
                    <small class="text-muted">
                      <span
                        v-for="(promo, idx) in item.applied_promotions"
                        :key="idx"
                      >
                        {{ promo.promotionName }}
                        <span v-if="idx < item.applied_promotions.length - 1">, </span>
                      </span>
                    </small>
                  </div>
                </div>
                <div
                  v-for="modifierGroup in getModifiersByItemPosition(item.id)"
                  :key="modifierGroup.id"
                  class="mod"
                >
                  <div class="d-flex align-items-center justify-content-between sub text-nowrap">
                    <div class="text-left mod-name">
                      {{ modifierGroup.name }}
                    </div>
                    <div class="text-right" />
                  </div>
                  <div
                    v-for="modifier of modifierGroup.modifiers"
                    :key="modifier.id"
                    class="d-flex align-items-center justify-content-between sub text-nowrap"
                  >
                    <div class="text-left">
                      {{ modifier.name }}
                    </div>
                    <div class="text-right">
                      {{ currency }} {{ (modifier.price).toFixed(2) }}
                    </div>
                  </div>
                </div>
                <table
                  v-if="item.name === 'Points Redeemed'"
                  class="table mb-0"
                >
                  <tr>
                    <td class="border-0 text-center">
                      <b-button
                        disabled
                        variant="link"
                        class="text-decoration-none"
                      >
                        <span class="d-block text-muted small">{{ $t("listvieworderdelegate.qty") }}</span>
                        <strong class="text-primary">{{ item.quantity }}</strong>
                      </b-button>
                    </td>
                    <td class="border-0 text-center">
                      <b-button
                        disabled
                        variant="link"
                        class="text-decoration-none"
                      >
                        <span class="d-block text-muted small">{{ $t("listvieworderdelegate.price") }}</span>
                        <strong class="text-primary">{{ currency }} {{ getItemPriceDisplay(item) }}</strong>
                      </b-button>
                    </td>
                    <td class="border-0 text-center">
                      <b-button
                        variant="link"
                        class="btn-remove"
                        @click="removeItemFromOrder(item.id)"
                      >
                        <svg class="icon icon-icon-remove">
                          <use xlink:href="#icon-icon-remove" />
                        </svg>
                      </b-button>
                    </td>
                  </tr>
                </table>

                <table
                  v-else-if="item.product === -2"
                  class="table mb-0"
                >
                  <tr>
                    <td class="border-0 text-center">
                      <b-button
                        variant="link"
                        @click="showPriceAdjustModal(item)"
                      >
                        <span>Load Amount</span>
                        <strong class="text-primary">{{ currency }} {{ getItemPriceDisplay(item) }}</strong>
                      </b-button>
                    </td>
                    <td class="border-0 text-center">
                      <b-button
                        variant="link"
                        class="btn-remove"
                        @click="removeItemFromOrder(item.id)"
                      >
                        <svg class="icon icon-icon-remove">
                          <use xlink:href="#icon-icon-remove" />
                        </svg>
                      </b-button>
                    </td>
                  </tr>
                </table>

                <table
                  v-else
                  class="table"
                >
                  <tr>
                    <td>
                      <b-button
                        variant="link"
                        @click="changeQuantity(item.id)"
                      >
                        <span>
                          {{ $t("listvieworderdelegate.qty") }}
                        </span>
                        <strong class="text-primary">
                          {{ item.quantity }}
                        </strong>
                      </b-button>
                    </td>
                    <td>
                      <b-button
                        :ref="`showPriceAdjust`"
                        variant="link"
                        @click="showPriceAdjustModal(item)"
                      >
                        <span>
                          {{ $t("listvieworderdelegate.price") }}
                        </span>
                        <strong class="text-primary">
                          {{ currency }} {{ getItemPriceDisplay(item) }}
                        </strong>
                      </b-button>
                    </td>
                    <td>
                      <b-button
                        variant="link"
                        :disabled="item.allow_discounts === false || disableManualDiscount"
                        @click="changeDiscount(item.id)"
                      >
                        <span>
                          {{ $t("listvieworderdelegate.discount") }}
                        </span>
                        <strong>
                          {{ currency }} {{ item.discount.toFixed(2) }}
                        </strong>
                      </b-button>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <b-button
                        variant="link"
                        @click="showNotesModal(item)"
                      >
                        {{
                          !(item.notes && item.notes.length) ? $t("listvieworderdelegate.add-notes") :
                          $t("listvieworderdelegate.edit-note")
                        }}
                      </b-button>
                    </td>
                    <td>
                      <b-button
                        v-if="(products.find(product => product.id === item.product)).modifier_groups.length > 0"
                        variant="link"
                        class="text-danger"
                        @click="modifiersOpen(item.id)"
                      >
                        {{ $t("listvieworderdelegate.modifiers") }}
                      </b-button>
                    </td>
                    <td>
                      <b-button
                        variant="link"
                        class="btn-remove"
                        @click="removeItemFromOrder(item.id)"
                      >
                        <svg class="icon icon-icon-remove">
                          <use xlink:href="#icon-icon-remove" />
                        </svg>
                      </b-button>
                    </td>
                  </tr>
                </table>
                <div
                  v-if="item.notes && item.notes.length"
                  class="card-notes"
                >
                  {{ item.notes }}
                </div>
              </b-card-body>
            </b-collapse>
          </b-card>
        </div>

        <div v-if="isKioskMode">
          <b-card
            v-for="(item) in itemsAtCurrentOrder"
            :key="item.id"
            no-body
            class="list-complete-item test"
            @click="changeQuantity(item.id)"
          >
            <div class="card-header p-0 test">
              <div class="d-flex align-items-center justify-content-between">
                <b-button
                  class="card-qnt"
                  variant="link"
                >
                  <span class="bg-primary text-white">
                    {{ item.quantity }}
                  </span>
                </b-button>

                <h6 class="card-title mb-0">
                  {{ getItemDisplayName(item) }}
                </h6>

                <div class="card-price ml-auto">
                  <span
                    v-if="item.tax > 0 && item.tax_status === 0 && !isKioskMode"
                    class="short-desc"
                  >{{
                    $t("listvieworderdelegate.taxed") }}</span>
                  <span>
                    {{ currency }} {{ getItemPriceDisplay(item) }}
                  </span>
                </div>

                <b-button
                  variant="link"
                  class="btn-remove ml-1"
                  @click.stop.prevent="removeItemFromOrder(item.id)"
                >
                  <svg class="icon icon-icon-remove">
                    <use xlink:href="#icon-icon-remove" />
                  </svg>
                </b-button>
              </div>

              <div
                v-for="modifierGroup in getModifiersByItemPosition(item.id)"
                :key="modifierGroup.id"
                class="mod"
              >
                <div class="d-flex align-items-center justify-content-between sub text-nowrap">
                  <div class="text-left mod-name">
                    {{ modifierGroup.name }}
                  </div>
                  <div class="text-right" />
                </div>
                <div
                  v-for="modifier of modifierGroup.modifiers"
                  :key="modifier.id"
                  class="d-flex align-items-center justify-content-between sub text-nowrap"
                >
                  <div class="text-left">
                    {{ modifier.name }}
                  </div>
                  <div class="text-right">
                    {{ currency }} {{ (modifier.price).toFixed(2) }}
                  </div>
                </div>
              </div>
            </div>
          </b-card>
        </div>
      </div>
    </div>

    <div class="orders-bottom">
      <div v-if="!isDisplayPaymentDetails">
        <div class="orders-bottom-item">
          <span class="text-left">
            {{ $t("ordertotal.total") }}
          </span>
          <span class="text-right">
            {{ currency }} {{ currentOrder.grand_total ? currentOrder.grand_total.toFixed(2) : "0.00" }}
            <b-button
              variant="link"
              class="w-100"
              @click="displayPaymentDetails"
            >
              {{ $t("ordertotal.view-details") }}
            </b-button>
          </span>
        </div>
      </div>
      <div v-else>
        <div class="orders-bottom-item">
          <b-button
            variant="link"
            class="w-100 text-center"
            @click="displayPaymentDetails"
          >
            {{ $t("ordertotal.close-details") }}
          </b-button>
        </div>
        <div class="orders-bottom-item">
          <span class="text-left">
            {{ $t("ordertotal.discount") }}
            <template v-if="currentOrder.promotion_applied">
              <span
                v-if="currentOrder.applied_order_promotions && currentOrder.applied_order_promotions.length > 0"
                v-for="(promo, idx) in currentOrder.applied_order_promotions"
                :key="idx"
                class="badge badge-info ml-1"
              >{{ promo.promotionName }}</span>
              <span
                v-else
                class="badge badge-info ml-1"
              >PROMO</span>
            </template>
          </span>
          <span class="text-left">
            {{ currency }} {{ currentOrder ? currentOrder.discount_total.toFixed(2) : "0.00" }}
          </span>
        </div>
        <div
          v-if="currentOrder.applied_order_promotions && currentOrder.applied_order_promotions.length > 0"
          class="orders-bottom-item"
        >
          <span class="text-left">
            <small class="text-muted">
              <span
                v-for="(promo, idx) in currentOrder.applied_order_promotions"
                :key="idx"
              >
                {{ promo.promotionName }}
                <span v-if="idx < currentOrder.applied_order_promotions.length - 1">, </span>
              </span>
            </small>
          </span>
        </div>

        <div class="orders-bottom-item">
          <span class="text-left">
            {{ $t("ordertotal.sub-total") }}
          </span>
          <span class="text-right">
            {{ currency }} {{ currentOrder ? currentOrder.subtotal.toFixed(2) : "0.00" }}
          </span>
        </div>

        <div class="orders-bottom-item">
          <span class="text-primary text-left">
            {{ $t("ordertotal.tax") }}
          </span>
          <span class="text-right">
            {{ currency }} {{ currentOrder ? currentOrder.tax_total.toFixed(2) : "0.00" }}
          </span>
        </div>
        <div class="orders-bottom-item">
          <span class="text-left">
            {{ $t("ordertotal.total") }}
          </span>
          <span class="text-right">
            {{ currency }} {{ currentOrder.grand_total ? currentOrder.grand_total.toFixed(2) : "0.00" }}
          </span>
        </div>
        <div
          v-for="(payment, index) in paymentsCashEntries"
          :key="index"
          class="orders-bottom-item"
        >
          <span class="text-left">
            {{ $t("ordertotal.paid") }} - {{ payment.payment_type }}
          </span>
          <span class="text-right">
            {{ currency }} {{ payment.amount.toFixed(2) }}
            <span :style="{ color: 'red' }">
              {{ `(${payment.change_amount.toFixed(2)})` }}
            </span>
          </span>
        </div>
      </div>
      <div class="orders-bottom-options">
        <div
          v-if="isPaymentTypesAvailable && showCheckoutButton"
          :class="{ 'disabled':!isPaymentTypesAvailable }"
          class="pay"
          :style="{
            'background-color': activeRefund ? 'red' : ''}"
          @click="goToCheckout()"
        >
          <div class="d-flex align-items-center justify-content-between">
            <span
              v-if="activeRefund"
              class="text-left"
            >
              {{ $t("orderscreenv1.refund") }}
            </span>
            <!-- <span
            v-if="activeRefund && isGiftCardRefund"
            class="text-left"
          >
          Reimburse
          </span> -->
            <span
              v-else
              class="text-left"
            >
              {{ isKioskMode ? "Checkout" : $t("orderscreen.pay") }}
            </span>

            <span class="text-right">
              {{ currency }} {{ currentOrderSum ? currentOrderSum.toFixed(2) : "0.00" }}
            </span>
          </div>
        </div>
      </div>

      <!-- Print panel For desktop -->
      <div
        v-if="!isKioskMode"
        class="print d-none d-md-block"
      >
        <b-row class="h-100 no-gutters">
          <b-col
            cols="3"
            class="h-100"
          >
            <b-button
              :class="{ 'btn-disabled': itemsAtCurrentOrder.length === 0 }"
              :title="{ 'No active items': itemsAtCurrentOrder.length === 0 }"
              variant="link"
              class="w-100"
              @click="printCheck()"
            >
              <svg class="icon icon-icon-print-1">
                <use xlink:href="#icon-icon-print-1" />
              </svg>
              <span>
                {{ $t("amountandpaymentmethod.print-check") }}
              </span>
            </b-button>
          </b-col>
          <b-col
            v-if="!isRetailMode"
            cols="3"
            class="h-100"
          >
            <div
              v-if="isKitchenPrintProcessing"
              class="text-center spiner-overbutton"
            >
              <b-spinner
                variant="primary"
                label="Text Centered"
              />
            </div>
            <b-button
              :class="{ 'btn-disabled': !kitchenUpdatesAvailable || isKitchenPrintProcessing}"
              variant="link"
              class="w-100"
              @click="printKitchenCheck()"
            >
              <svg class="icon icon-icon-print-2">
                <use xlink:href="#icon-icon-print-2" />
              </svg>

              <span>
                {{ $t("amountandpaymentmethod.kitchen-print") }}
              </span>
            </b-button>
          </b-col>
          <b-col
            v-if="isRetailMode"
            cols="3"
            class="h-100"
          >
            <b-button
              variant="link"
              class="w-100"
              :disabled="disableManualDiscount"
              @click="openOrderDiscountModal()"
            >
              <svg class="icon icon-icon-discount">
                <use xlink:href="#icon-icon-discount" />
              </svg>

              <span>
                {{ $t("discountpopup.discount") }}
              </span>
            </b-button>
          </b-col>
          <b-col
            cols="3"
            class="h-100 d-none d-md-block"
          >
            <b-button
              variant="link"
              class="w-100"
              @click="openDrawer()"
            >
              <svg class="icon icon-icon-print-3">
                <use xlink:href="#icon-icon-print-3" />
              </svg>

              <span>
                {{ $t("amountandpaymentmethod.open-drawer") }}
              </span>
            </b-button>
          </b-col>
          <b-col
            cols="3"
            class="h-100 d-none d-md-block"
          >
            <b-button
              :class="{ 'btn-disabled': isSavingProcess }"
              variant="link"
              class="w-100"
              @click="showMoreOptionModal()"
            >
              <svg class="icon icon-icon-more-options">
                <use xlink:href="#icon-icon-more-options" />
              </svg>

              <span>
                {{ $t("amountandpaymentmethod.more-options") }}
              </span>
            </b-button>
          </b-col>
        </b-row>
        <MoreOptionsModal
          v-if="employee"
          :current-order="currentOrder"
          :terminal-mode="terminalMode"
          :currency="currency"
          :current-employee="employee"
          :all-discounts="allDiscounts"
          @save-discount-to-order="saveDiscountToOrder"
        />
      </div>
    </div>

    <CustomerModal
      :view-customer="viewCustomer"
      :is-selected="true"
      :index="2"
      @close-modal="clearViewCustomer"
    />
    <LeaveCurrentOrderModal
      @cancel-order="$emit('cancelOrder')"
    />
    <HoldOrder @hold-order="holdOrder" />
  </div>
</template>

<script>
import orderMixin from "../../mixins/order/orderMixin";
import printMixin from "../../mixins/printMixin";
import syncMixin from "../../mixins/syncMixin";
import orderModifierMixin from "../../mixins/order/modifier";
import viewCustomerModalMixin from "../../mixins/modals/viewCustomerModalMixin";
import MoreOptionsModal from "../../modals/Order/MoreOptions/MoreOptionsModal";
import CustomerModal from "@/modals/CustomerModal";
import LeaveCurrentOrderModal from "../../modals/Order/LeaveCurrentOrderModal.vue";
import HoldOrder from "../../modals/Order/MoreOptions/HoldOrder.vue";
// import { getItemGrandTotal} from "@/helpers/calc";
import { mapGetters, mapActions } from 'vuex'
import { toFixedNoRounding } from "@/helpers/utils";

export default {
    name: 'OrderPanel',
    components: {
      MoreOptionsModal,
      CustomerModal,
      LeaveCurrentOrderModal,
      HoldOrder
    },
    props: {
        effectiveCustomerPoints: {
          type: Number,
          default: 0
        },
        currentOrder: {
        type: Object,
        default: () => ({})
        },
        discountEmployee: {
          type: Object,
          default: null
        },
        orderPanelOrderDiningOption: {
          type: Object,
            default: () => ({})
        },
        defaultDiningOption: {
          type: Object,
            default: () => ({})
        },
        paymentsCashEntries: {
          type: Array,
            default: () => ([])
        },
        currentOrderSum: {
          type: Number,
            default:0
        },
        orderPanelTable: {
          type: Object,
            default: () => ({})
        },
        isDisplayPaymentDetails: {
            type: Boolean,
            default:false
        },
        isLoad: {
            type: Boolean,
            default: false
        },
        allDiscounts: {
            type: Array,
            default: () => ([])
        },
        // isKitchenPrintProcessing is provided by printMixin, no need to pass as prop
        discount: {
            type: Object,
            default: () => ({
                val: "",
                changed: false,
                type: 1
            })
        },
        orderItems: {
            type: Array,
            default:()=>([])
        },
        // giftCards: {
        //   type: Array,
        //   default: ()=>([])
        // }
    },
    mixins: [orderMixin, printMixin, orderModifierMixin, viewCustomerModalMixin, syncMixin],

    computed: {
        ...mapGetters({
            isOnline: "connection",
            terminalMode: "terminalMode",
            isShiftOpen: "isShiftOpen",
            products: "config/products",
            categories: "config/categories",
            employee: "employee",
            store: "config/store",
            isSavingProcess: "isSavingProcess",
            isKioskMode: "config/isKioskMode",
            updatingOrder: "orders/getUpdatingOrder",
            currency: "config/currency",
            refundItems: 'orders/refundItems',
            refundOrderId: 'orders/refundOrderId',
            activeGiftCard: 'giftVoucher/activeGiftCard',
            selectedGiftCards:"giftVoucher/selectedGiftCards",
            getTableById: "config/getTableById",
            terminal: 'config/terminal',
        }),
      isRewardsModuleEnabled() {
        if (this.terminal && this.terminal.db_settings) {
          const rewardsSetting = this.terminal.db_settings.find(setting => setting.name === 'rewards_module');
          return rewardsSetting ? rewardsSetting.value === 'true' : false;
        }
        return false;
      },
      isRetailMode() {
        // Check if retail_mode db_setting is true
        if (this.terminal && this.terminal.db_settings) {
          const retailModeSetting = this.terminal.db_settings.find(setting => setting.name === 'retail_mode');
          return retailModeSetting ? retailModeSetting.value === 'true' : false;
        }
        return false;
      },
      disableManualDiscount() {
        // Check if disable_manual_discount db_setting is true
        if (this.terminal && this.terminal.db_settings) {
          const disableManualDiscountSetting = this.terminal.db_settings.find(setting => setting.name === 'disable_manual_discount');
          return disableManualDiscountSetting ? disableManualDiscountSetting.value === 'true' : false;
        }
        return false;
      },
      showCheckoutButton() {
        if ((this.currentOrder.items.length >= 0.00 && this.currentOrder.items.find(item => item.void_status === 0)))
          return true
          return false
      },
      activeRefund() {
        if (this.currentOrderSum < 0.00 && this.currentOrder.items.find(item => item.quantity < 0 && item.void_status === 0))
          return true
      return false
      },
      displayOrderWithTable() {
        const orderId = this.currentOrder.id || this.currentOrder.local_id;

        // If order has a table, get the table name
        if (this.currentOrder.table && this.getTableById) {
          const table = this.getTableById(this.currentOrder.table);
          if (table && table.table_name) {
            return `${table.table_name} / ${orderId}`;
          }
        }

        return orderId;
      }
    },
  methods: {
    ...mapActions({
      setGiftVoucherVisiblity:'giftVoucher/setGiftVoucherVisiblity'
    }),
        toFixedNoRounding,

        showDiningOptionsModal() {
            this.$emit('showDiningOptionsModal')

        },
        async showSelectCustomerModal() {
            this.$emit('showSelectCustomerModal')

        },
        showPriceAdjustModal(item) {
            this.$emit('showPriceAdjustModal',item)

        },
        showNotesModal(item) {
            this.$emit('showNotesModal',item)

        },
        displayPaymentDetails() {
            this.$emit('displayPaymentDetails')

        },
        async goToCheckout() {
            this.$emit('goToCheckout')

        },
        async holdOrder(payload) {
            this.$emit('holdOrder',payload)

        },
        async saveDiscountToOrder(value, discountType) {
            const payload = {
                value,
                discountType
            }
            this.$emit('saveDiscountToOrder',payload)

        },
        changeDiscount(itemId, name=null) {
          if(!name)
            this.$emit("changeDiscount",itemId)

        },
        modifiersOpen(itemId) {
            this.$emit("modifiersOpen", itemId)
        },
        showCollapse(index) {
            return this.itemsAtCurrentOrder.length > 0 && this.itemsAtCurrentOrder.length - 1 === index
        },
        scrollToBottom() {
          /**
           *  Scroll to the bottom of the container orders-side-body
           *
           */
            var scrollableDiv = document.getElementById('orders-sidebar-body');
            if(scrollableDiv)
              scrollableDiv.scrollTop = scrollableDiv.scrollHeight;
        },
        async showMoreOptionModal(){
          // this.checkInternetConnectivity().then((res)=>{this.setGiftVoucherVisiblity(res)}).catch(err=>{{this.setGiftVoucherVisiblity(err)}})
          this.$bvModal.show('more-options-modal')
        },
        openOrderDiscountModal() {
          /**
           * This function opens the order discount modal directly when retail_mode is enabled
           * It's called from the Discount button that replaces Kitchen Print
           */
          this.$bvModal.show('modal-order-discount');
        },
        getGiftCardNumber(local_id){
          return this.selectedGiftCards.find(card=>card.order_item_local_id === local_id)?.card_number
        },
        getCustomerInitials(customer) {
          if (!customer) return '';
          const first = customer.first_name ? customer.first_name.charAt(0).toUpperCase() : '';
          const last = customer.last_name ? customer.last_name.charAt(0).toUpperCase() : '';
          return `${first}${last}`;
        },
        getEmployeeInitials(employee) {
          if (!employee || !employee.name) return '';
          const parts = employee.name.trim().split(/\s+/);
          const first = parts[0] ? parts[0].charAt(0).toUpperCase() : '';
          const last = parts.length > 1 ? parts[parts.length - 1].charAt(0).toUpperCase() : '';
          return `${first}${last}`;
        },
        getItemDisplayName(item) {
          // Check if kitchen_name_pos is enabled
          const kitchenNamePosSetting = this.terminal?.db_settings?.find(s => s.name === 'kitchen_name_pos');
          const isKitchenNamePosEnabled = kitchenNamePosSetting && kitchenNamePosSetting.value === 'true';

          if (isKitchenNamePosEnabled && item.product) {
            // Find the product
            const product = this.products.find(p => p.id === item.product);

            // If product found and has kitchen_display_name, use it
            if (product && product.kitchen_display_name) {
              return product.kitchen_display_name;
            }
          }

          // Fallback to item name
          return item.name;
        }
    },
  watch: {
    orderItems() {
      // scroll to the bottom of the list as the item adds on after a awaiting of 10 milisec
      setTimeout(this.scrollToBottom, 10);
    }
  }
}
</script>
<style lang="scss" scoped>
.f-small{
  font-size:small;
}

.points-redeemed-item{
  border: 1px solid rgba(214, 160, 16, 0.35);
  box-shadow: 0 2px 10px rgba(214, 160, 16, 0.12);
}

.points-redeemed-head{
  background: linear-gradient(90deg, rgba(255, 236, 179, 0.55), rgba(255, 215, 0, 0.28));
}

.badge-rewards{
  font-weight: 700;
  letter-spacing: 0.02em;
  color: #6b4d00;
  background: linear-gradient(120deg, #fff3b0, #ffd54a, #fff3b0);
  background-size: 200% 100%;
  border: 1px solid rgba(214, 160, 16, 0.55);
  box-shadow: 0 1px 6px rgba(214, 160, 16, 0.18);
  padding: 0.22rem 0.45rem;
  border-radius: 0.35rem;
  font-size: 0.72em;
  text-transform: uppercase;
  animation: rewardsShimmer 1.8s ease-in-out infinite;
}

@keyframes rewardsShimmer {
  0% { background-position: 0% 0%; }
  50% { background-position: 100% 0%; }
  100% { background-position: 0% 0%; }
}

.customer-avatar {
  width: 40px;
  height: 40px;
  background-color: #e0e0e0;
  color: #000;
  font-weight: 500;
  font-size: 1.1rem;
}
.btn-points {
  background-color: #ffc107 !important; /* Bootstrap warning color usually, but explicit yellow requested */
  color: #fff !important;
  font-size: 1rem;
}
.btn-view {
  background-color: #2196F3 !important; /* Material Blue */
  color: #fff !important;
  font-size: 1rem;
}
</style>
